export const ACCESS_TOKEN_KEY_NAME = 'access_token'
export const REFRESH_TOKEN_KEY_NAME = 'refresh_token'
